import React, { useState } from "react";
import styles from "./MaterialManagement.module.css";
import { Select, Table } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Actionicon } from "../../../../assets/images/actionicon.svg";
import { Dropdown, SubmitButton, TextComponent } from "../../../../components";

const MaterialManagement = () => {
  const [actions, setActions] = useState(null);
  const navigate = useNavigate();
  const { Option } = Select;

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "No",
      width: "50px",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Material Name",
      dataIndex: "material_name",
      key: "material_name",
      width: "400px",
      align: "center",

      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
      width: "150px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },
    {
      title: "Category",
      key: "Category",
      dataIndex: "Category",
      width: "400px",
      align: "center",
      render: (text, record) => (
        <div className={styles.materialName}>
          <TextComponent className={styles.materialText} text={text} />
        </div>
      ),
    },

    {
      title: "Action",
      key: "Action",
      dataIndex: "Action",
      width: "300px",
      align: "center",

      render: (text) => (
        <Dropdown
          fontFamily={"poppins-medium"}
          value={text}
          inputStyle={{
            border: "1.5px solid #E8ECF4",
            // width: "70%",
          }}
          main_input={styles.mainInput}
          inputClass={styles.DropdownInput}
          style={{ color: "var(--black-color)" }}
          options={[
            {
              value: "View",
              role: "View",
              id: 1,
            },
            {
              value: "Edit",
              role: "Edit",
              id: 2,
            },
            {
              value: "Archive",
              role: "Archive",
              id: 3,
            },
          ]}
          // onChange={(e) => setActions(e)}
        />
      ),
    },
    {
      title: "",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => (
        <div>
          <SubmitButton
            title={"Continue"}
            btnClass={styles.tableBtn}
            primary
          />
        </div>
      ),
    },
  ];

  const data = [
    {
      No: "1",
      material_name: "Bread Flour",
      Quantity: "2 lbs",
      Category: "Flour",
      ShelfLife: "180 days",
      Action: "View",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "2",
      material_name: "Instant Yeast",
      Quantity: "36 oz",
      Category: "Additives",
      ShelfLife: "2 years",
      Action: "Edit",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "3",
      material_name: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Liquids",
      ShelfLife: "12 months",
      Action: "Archive",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "4",
      material_name: "Margarine",
      Quantity: "4 g",
      Category: "Toppings",
      ShelfLife: "180 days",
      Action: "Archive",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "5",
      material_name: "Olive oil",
      Quantity: "36 oz",
      Category: "Liquids",
      ShelfLife: "2 years",
      Action: "View",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "6",
      material_name: "Whole milk",
      Quantity: "3 lbs",
      Category: "Additives",
      ShelfLife: "12 months",
      Action: "View",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "7",
      material_name: "Almonds",
      Quantity: "2 lbs",
      Category: "Toppings",
      ShelfLife: "12 months",
      Action: "Edit",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "8",
      material_name: "Buttermilk",
      Quantity: "4 g",
      Category: "Liquids",
      ShelfLife: "180 Days",
      Action: "Archive",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
    {
      No: "9",
      material_name: "Brown sugar",
      Quantity: "3 lbs",
      Category: "Toppings",
      ShelfLife: "2 years",
      Action: "View",
      Button: <button className={styles.TableButton}>Continue</button>,
    },
  ];

  return (
    <div className={styles.mainCont}>
      {/* Heading Section with Right Controls */}
      {/* Table Section */}
      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey="No"
          rowClassName={styles.tableRow}
        />
      </div>
    </div>
  );
};

export default MaterialManagement;
